import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import CheckoutForm from "../components/CheckoutForm";
import FormContainer from "../components/FormContainer";
import StepsHeader from "../components/StepsHeader";
import StepsNotification from "../components/StepsNotification";
import { getUserRequest, savePaymentMethod } from "../redux/actions";
import { AppState } from "../redux/types";
import { localePath } from "../i18n/config";
import { CATEGORIES, categoryOptions, getPricingRegion, SHIPPING_METHODS, STRIPE_PUBLIC_KEY } from "../utils/constants";

const PaymentMethod = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const cart = useSelector((state: AppState) => state.cart);
    const user = useSelector((state: AppState) => state.user);
    const rawCategory = useSelector((state: AppState) => state.categories.category?.attributes.slug);
    const regionCode = useSelector((state: AppState) => state.region?.code ?? "FI");
    const category = CATEGORIES[rawCategory as keyof typeof CATEGORIES] || rawCategory;
    const isFinnishRegion = getPricingRegion(regionCode) === "FI";

    const { shippingMethod, address, postalCode, city, paymentMethod: savedPaymentMethod } = cart;

    const [paymentMethod, setPaymentMethod] = useState(isFinnishRegion ? savedPaymentMethod || "card" : "card");
    const [stripePaymentMethod, setStripePaymentMethod] = useState("");
    const [btnDisabled, setBtnDisabled] = useState(true);

    const stripeKey = user.stripePublicKey?.trim() || (category === categoryOptions.alarm || category === categoryOptions.accessories ? STRIPE_PUBLIC_KEY : "");

    useEffect(() => {
        if ((shippingMethod === SHIPPING_METHODS.posti || shippingMethod === SHIPPING_METHODS.posti_gadgets) && (!address || !postalCode || !city)) {
            history.push(localePath("toimitus"));
        }
    }, [shippingMethod, address, postalCode, city, history]);

    useEffect(() => {
        if (user.id && !user.stripePublicKey) {
            dispatch(getUserRequest(user.id));
        }
    }, [user.id, user.stripePublicKey, dispatch]);

    useEffect(() => {
        if (!isFinnishRegion && paymentMethod !== "card") {
            setPaymentMethod("card");
        }
    }, [isFinnishRegion, paymentMethod]);

    useEffect(() => {
        if (paymentMethod === "card" && !stripePaymentMethod) {
            setBtnDisabled(true);
        } else {
            setBtnDisabled(false);
        }
    }, [paymentMethod, stripePaymentMethod]);

    const handleBackClick = () => {
        history.push(localePath("toimitus"));
    };

    const submitHandler = (e: React.FormEvent) => {
        e.preventDefault();
        dispatch(savePaymentMethod(paymentMethod));
        history.push(localePath("tee_tilaus"));
    };

    const hasValidStripeKey = !!stripeKey;
    const showCheckoutForm = hasValidStripeKey && paymentMethod === "card";

    return (
        <>
            <StepsHeader step1 step2 step3 step4 user={2} payment={1} account={1} />
            <FormContainer>
                <h1 className="paymentmethod-header">Valitse maksutapa</h1>
                <Form.Group>
                    <Col className="paymentmethod-col">
                        <Form.Check className="radio-button" type="radio" label="Pankki- tai luottokortti" id="card" name="paymentMethod" value="card" checked={paymentMethod === "card"} onChange={(e) => setPaymentMethod(e.target.value)} />
                        {showCheckoutForm ? (
                            <CheckoutForm stripePublicKey={stripeKey} setSPM={setStripePaymentMethod} handleForm={submitHandler} handleBack={handleBackClick} />
                        ) : (
                            paymentMethod === "card" && (
                                <div>
                                    <small className="password-length">Stripe is loading...</small>
                                </div>
                            )
                        )}
                        {isFinnishRegion && category !== categoryOptions.accessories && (
                            <>
                                <Form.Check
                                    className="radio-button"
                                    type="radio"
                                    label="Sähköpostilasku"
                                    id="email_billing"
                                    name="paymentMethod"
                                    value="email_billing"
                                    checked={paymentMethod === "email_billing"}
                                    onChange={(e) => setPaymentMethod(e.target.value)}
                                />
                                {paymentMethod === "email_billing" && (
                                    <small className="for-example">Emme suosittele tätä laskutusmuotoa, koska se hidastaa palvelun käyttöönottoa ja palvelun toistuvaisveloitukset ovat asiakkaalle työläämpiä.</small>
                                )}
                                <Form.Check
                                    className="radio-button"
                                    type="radio"
                                    label="Laskutussopimus kotisairaanhoidon, hoivakodin tai palveluasunnon kautta"
                                    id="contract_billing"
                                    name="paymentMethod"
                                    value="contract_billing"
                                    checked={paymentMethod === "contract_billing"}
                                    onChange={(e) => setPaymentMethod(e.target.value)}
                                />
                            </>
                        )}
                    </Col>
                </Form.Group>
                {!btnDisabled && (
                    <Row className="my-4">
                        <Col xs={6}>
                            <Button className="tallenna paymentmethod-back-button" type="button" onClick={handleBackClick}>
                                Takaisin
                            </Button>
                        </Col>
                        <Col xs={6} className="text-right">
                            <Button className="tallenna" type="button" disabled={btnDisabled} onClick={submitHandler}>
                                Seuraava
                            </Button>
                        </Col>
                    </Row>
                )}
            </FormContainer>
            <StepsNotification />
        </>
    );
};

export default PaymentMethod;
